import React from 'react';
import { jsx } from 'react/jsx-runtime';

const Memorize = new Map();

const Cache = new Map();

class Parser {
  static parse(string) {
    if (string === void 0) {
      string = "";
    }
    if (Cache.has(string)) {
      return Cache.get(string);
    }
    const keys = this.keys();
    const statics = this.statics();
    const auto = this.auto();
    const style = {};
    let classes = "";
    if (typeof string === "string") {
      const items = string.split(" ");
      const _items = [];
      items.forEach((item, b) => {
        if (item.includes("@")) {
          return this.transform(item).split(" ").map(i => _items.push(i));
        }
        return _items.push(item);
      });
      _items.forEach(item => {
        const values = item.split(":");
        if (values.length === 2) {
          const name = values[0] || "";
          const value = values[1] || "";
          if (statics.includes(name)) {
            classes += `${item} `;
            return;
          }
          if (auto?.[name]?.includes(value)) {
            classes += `${item} `;
            return;
          }
          const _value = value.includes("#") && Memorize.has(value) ? Memorize.get(value) : value;
          if (Memorize.has(name) && name.includes("-")) {
            style[Memorize.get(name)] = isNaN(_value) ? _value : parseFloat(_value, 10);
          } else {
            if (value.includes("?")) {
              style[keys[name]] = `var(--${value.replaceAll("?", "")})`;
            } else if (keys[name]) {
              style[keys[name]] = isNaN(_value) ? _value : parseFloat(_value, 10);
            }
          }
        }
      });
    }
    Cache.set(string, {
      style,
      classes
    });
    return {
      style,
      classes
    };
  }
  static transform(item) {
    if (item === void 0) {
      item = "";
    }
    if (Memorize.has(item)) {
      return Memorize.get(item);
    }
    return {
      fc: "d:flex a:center j:center",
      ifc: "d:inline-flex a:center j:center"
    }[item.replaceAll("@", "")] || "";
  }
  static keys() {
    return {
      i: "zIndex",
      w: "width",
      ws: "whiteSpace",
      t: "top",
      ta: "textAlign",
      r: "right",
      p: "position",
      pt: "paddingTop",
      pr: "paddingRight",
      pl: "paddingLeft",
      pb: "paddingBottom",
      pa: "padding",
      oa: "overflow",
      ox: "overflowX",
      oy: "overflowY",
      o: "opacity",
      mw: "minWidth",
      mh: "minHeight",
      mxw: "maxWidth",
      mxh: "maxHeight",
      mt: "marginTop",
      mr: "marginRight",
      ml: "marginLeft",
      mb: "marginBottom",
      ma: "margin",
      l: "left",
      b: "bottom",
      a: "alignItems",
      j: "justifyContent",
      h: "height",
      d: "display",
      fw: "flexWrap",
      fd: "flexDirection",
      f: "flex",
      c: "backgroundColor",
      br: "borderRadius"
    };
  }
  static statics() {
    return ["ws", "ta", "oa", "ox", "oy", "a", "j", "d", "fw", "fd", "f", "p"];
  }
  static auto() {
    return {
      w: ["0", "auto", "inherit", "unset", "100%", "0%"],
      h: ["0", "auto", "inherit", "unset", "100%", "0%"],
      mw: ["0", "auto", "inherit", "unset", "100%", "0%"],
      mh: ["0", "auto", "inherit", "unset", "100%", "0%"],
      mxh: ["0", "auto", "inherit", "unset", "100%", "0%"],
      mxh: ["0", "auto", "inherit", "unset", "100%", "0%"],
      pa: ["0", "auto", "inherit", "unset", "100%", "0%"],
      pt: ["0", "auto", "inherit", "unset", "100%", "0%"],
      pl: ["0", "auto", "inherit", "unset", "100%", "0%"],
      pr: ["0", "auto", "inherit", "unset", "100%", "0%"],
      pb: ["0", "auto", "inherit", "unset", "100%", "0%"],
      ma: ["0", "auto", "inherit", "unset", "100%", "0%"],
      mt: ["0", "auto", "inherit", "unset", "100%", "0%"],
      ml: ["0", "auto", "inherit", "unset", "100%", "0%"],
      mr: ["0", "auto", "inherit", "unset", "100%", "0%"],
      mb: ["0", "auto", "inherit", "unset", "100%", "0%"],
      t: ["0", "auto", "inherit", "unset", "100%", "0%"],
      l: ["0", "auto", "inherit", "unset", "100%", "0%"],
      r: ["0", "auto", "inherit", "unset", "100%", "0%"],
      b: ["0", "auto", "inherit", "unset", "100%", "0%"],
      o: ["0", "1", "0.5", "0.75", "0.25", "0.6", "0.6", "auto", "inherit", "unset"],
      br: ["0", "1", "2", "3", "5", "5", "10", "20", "25", "auto", "inherit", "unset"],
      z: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "99", "999", "9999", "auto", "inherit", "unset"]
    };
  }
  static declare(items) {
    if (items === void 0) {
      items = {};
    }
    Object.entries(items).forEach(_ref => {
      let [key, value] = _ref;
      Memorize.set(key, String(value));
    });
  }
  static memory() {
    return Memorize;
  }
}

const apply = function (styles, operations) {
  if (styles === void 0) {
    styles = {};
  }
  if (operations === void 0) {
    operations = [];
  }
  operations.forEach(operation => {
    const [rule = "", value = null, defaults = null] = operation;
    if (value) {
      styles[rule] = value;
    } else {
      if (defaults) {
        styles[rule] = defaults;
      }
    }
  });
  return styles;
};
const Box = _ref => {
  let {
    children,
    top,
    left,
    bottom,
    right,
    flex,
    align,
    justify,
    direction,
    wrap,
    color,
    radius,
    shadow,
    height,
    width,
    style,
    press,
    opacity,
    padding,
    margin,
    mode = "margin",
    position,
    overflow,
    display,
    border,
    css,
    layer,
    image,
    id,
    reference = false,
    parse = false,
    native = {},
    element = "div"
  } = _ref;
  const parsed = parse ? Parser.parse(parse) : {
    style: {},
    classes: ""
  };
  const styles = {
    ...apply({}, [["height", height], ["width", width], ["opacity", opacity], ["overflow", overflow], ["display", display], ["border", border], ["position", position], ["cursor", press ? "pointer" : undefined], ["backgroundColor", color], ["borderRadius", radius], ["flex", flex], ["flexDirection", direction], ["flexWrap", wrap], ["alignItems", align], ["justifyContent", justify], ["paddingTop", padding || mode === "padding" ? top : undefined], ["paddingLeft", padding || mode === "padding" ? left : undefined], ["paddingBottom", padding || mode === "padding" ? bottom : undefined], ["paddingRight", padding || mode === "padding" ? right : undefined], ["marginTop", margin || mode === "margin" ? top : undefined], ["marginLeft", margin || mode === "margin" ? left : undefined], ["marginBottom", margin || mode === "margin" ? bottom : undefined], ["marginRight", margin || mode === "margin" ? right : undefined], ["top", mode === "position" ? top : undefined], ["left", mode === "position" ? left : undefined], ["bottom", mode === "position" ? bottom : undefined], ["right", mode === "position" ? right : undefined], ["boxShadow", shadow], ["boxSizing", top || left || right || bottom ? "border-box" : undefined], ["zIndex", layer], ["backgroundImage", image], ["backgroundRepeat", image ? "no-repeat" : undefined], ["backgroundSize", image ? "cover" : undefined], ["backgroundPosition", image ? "center" : undefined]]),
    ...parsed.style,
    ...style
  };
  const Element = `${element}`;
  return /*#__PURE__*/jsx(Element, {
    ref: reference || undefined,
    id: id,
    onClick: press,
    style: styles,
    className: css ? `${String(parsed?.classes)}${css}` : `${String(parsed?.classes)}`,
    ...native,
    children: children
  });
};

const Component = _ref => {
  let {
    size = 16,
    family = "inherit",
    lines = false,
    press,
    style,
    children,
    right,
    left,
    top,
    bottom,
    margin = false,
    padding = false,
    mode = "margin",
    display = "inline",
    opacity,
    color = "#000000",
    line = false,
    align,
    weight = "400",
    to,
    target,
    css,
    id,
    referrer,
    tag = "span",
    native = {}
  } = _ref;
  const Tag = `${tag}`;
  return to ? /*#__PURE__*/jsx("a", {
    href: to,
    target: target,
    onClick: press,
    style: {
      display,
      opacity,
      color,
      textAlign: align,
      fontSize: size,
      fontFamily: family,
      fontWeight: weight,
      lineHeight: line ? line + "px" : undefined,
      cursor: press ? "pointer" : undefined,
      paddingTop: padding || mode === "padding" ? top : undefined,
      paddingLeft: padding || mode === "padding" ? left : undefined,
      paddingBottom: padding || mode === "padding" ? bottom : undefined,
      paddingRight: padding || mode === "padding" ? right : undefined,
      marginTop: margin || mode === "margin" ? top : undefined,
      marginLeft: margin || mode === "margin" ? left : undefined,
      marginBottom: margin || mode === "margin" ? bottom : undefined,
      marginRight: margin || mode === "margin" ? right : undefined,
      top: mode === "position" ? top : undefined,
      left: mode === "position" ? left : undefined,
      bottom: mode === "position" ? bottom : undefined,
      right: mode === "position" ? right : undefined,
      ...style
    },
    className: css,
    id: id,
    ref: referrer,
    ...native,
    children: children
  }) : /*#__PURE__*/jsx(Tag, {
    onClick: press,
    style: {
      display,
      opacity,
      color,
      textAlign: align,
      fontSize: size,
      fontFamily: family,
      fontWeight: weight,
      lineHeight: line ? line + "px" : undefined,
      cursor: press ? "pointer" : undefined,
      paddingTop: padding || mode === "padding" ? top : undefined,
      paddingLeft: padding || mode === "padding" ? left : undefined,
      paddingBottom: padding || mode === "padding" ? bottom : undefined,
      paddingRight: padding || mode === "padding" ? right : undefined,
      marginTop: margin || mode === "margin" ? top : undefined,
      marginLeft: margin || mode === "margin" ? left : undefined,
      marginBottom: margin || mode === "margin" ? bottom : undefined,
      marginRight: margin || mode === "margin" ? right : undefined,
      top: mode === "position" ? top : undefined,
      left: mode === "position" ? left : undefined,
      bottom: mode === "position" ? bottom : undefined,
      right: mode === "position" ? right : undefined,
      ...style
    },
    className: css,
    id: id,
    ref: referrer,
    ...native,
    children: children
  });
};

const Provider = _ref => {
  let {
    parse = "",
    render = () => null
  } = _ref;
  const styles = React.useMemo(() => parse ? Parser.parse(parse) : {}, [parse]);
  return render({
    styles,
    memory: Parser.memory()
  });
};

export { Box, Parser, Provider, Component as Text };
//# sourceMappingURL=index.esm.js.map
